export default [
  {
    path: "/chat",
    name: "Chat",
    component: () => import(/* webpackChunkName: "chat" */ "@/views/chat/chatView.vue"),
    meta: {
      navbarTitle: "Chat", // Titel für deine App-Bar
      hideBottomNavigation: true, // Oder true, je nachdem
      hideAvatar: true,
      hideLogo: true,
      hideAppBar: true,
      fullWidth: true, // Lässt den Chat die volle Breite nutzen
    },
  },
]
